import { Box } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { getNegotiations } from "src/apis/negotiation";
import { Negotiation } from "src/apis/negotiation";
import PageContainer from "src/pages/components/PageContainer";
import NegotiationsTable from "./components/NegotiationsTable";
import { isUserAdministrator, isUserPsychologist } from "src/utils/auth";
import RegisterFab from "src/pages/components/RegisterFab";

const Negotiations: FC = (): JSX.Element => {
  const [negotiations, setNegotiations] = useState<Negotiation[]>([]);
  const [error, setError] = useState<string>('');

  const fetchData = async (): Promise<void> => {
    try {
      const response = await getNegotiations();

      setNegotiations(response);
      setError('');
    } catch (err: any) {
      setError(err?.message);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Box>
      <PageContainer title="Negociações" error={error} guard={isUserPsychologist}>
        {isUserAdministrator() && (
          <RegisterFab registerUrl="/negociacao/cadastro" />
        )}

        <NegotiationsTable negotiations={negotiations} />
      </PageContainer>
    </Box>
  );
}

export default Negotiations; 
